export default __webpack_public_path__ + "static/media/simulation-scenario-icon.1f7658d9.svg";